<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleActivityUser(scope.row)">报名情况({{ scope.row.activity_user_count }})
                </el-button>
            </template>
        </avue-crud>

        <el-dialog title="报名情况" :visible.sync="dialogActivityUserVisible" width="80%" center>
            <ActivityUser :defaultParams="{activityId : this.activityId }"></ActivityUser>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import ActivityUser from './ActivityUser'

  export default {
    mixins: [curd],
    components: {ActivityUser},
    data() {
      return {
        dialogActivityUserVisible: false,
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增活动', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '活动名称',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '调查标题不能为空', trigger: 'blur'
              }]
            },
            {
              label: '所属分类',
              prop: 'cat_id',
              span: 24,
              type: 'select',
              props: {
                label: 'title',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/activity/category',
              rules: [{
                required: true, message: '分类不能为空', trigger: 'blur'
              }]
            },
            {
              label: '介绍图',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              type: 'upload',
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              hide: true,
              span: 24
            },
            {
              label: '活动时间',
              prop: 'time',
              span: 24,
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              rules: [{
                required: true, message: '活动时间不能为空', trigger: 'blur'
              }]
            },
            {
              label: '报名时间',
              prop: 'join_time',
              span: 24,
              type: 'daterange',
              rules: [{
                required: true, message: '报名不能为空', trigger: 'blur'
              }],
              valueFormat: 'yyyy-MM-dd',
              formatter: function (raw) {
                return raw.start_time + '—' + raw.end_time
              }
            },
            {
              label: '活动地址',
              span: 24,
              prop: 'address',
              hide: true,
              rules: [{
                required: true, message: '活动地址不能为空', trigger: 'blur'
              }]
            },
            {
              label: '报名状态',
              prop: 'status',
              span: 24,
              addDisplay: false,
              type: 'select',
              dicUrl: this.getDic('activity.status')
            },
            {   // 列表页展示
              label: '参与人数',
              prop: 'join_num',
              span: 24,
              display: false,
              html: true,
              formatter: function (row) {
                return '<span style="color: green">' + row.current_num + '</span>/' + row.max_num;
              }
            },
            {
              label: '限制人数',
              prop: 'max_num',
              span: 24,
              hide: true,
              type: 'number',
              rules: [{
                required: true, message: '人数不能为空', trigger: 'blur'
              }]
            },
            {
              label: '可带成人',
              prop: 'adult_num',
              hide: true,
              value: 0,
              span: 24,
              type: 'number'
            },
            {
              label: '可带儿童',
              prop: 'child_num',
              hide: true,
              span: 24,
              value: 0,
              type: 'number'
            },
            {
              label: '报名条件',
              prop: 'cond',
              hide: true,
              span: 24
            },
            {
              label: '联系人',
              hide: true,
              prop: 'tel',
              span: 24,
            },
            {
              label: '备注',
              prop: 'note',
              hide: true,
              span: 24,
              type: 'textarea'
            }
          ]
        },
        activityId: null,
      }
    },
    methods: {
      // 报名情况
      handleActivityUser(row) {
        this.dialogActivityUserVisible = true;
        this.activityId = row.id;
      }
    }
  }
</script>
